import ApplicationController from './application_controller'

export default class extends ApplicationController {
  static targets = ['element', 'checkbox', 'showOnHiddenOnlyElement', 'logofield', 'input', 'output', 'maintainfield']
  static values = { onHidden: Boolean, filename: String, errors: String }

  doConnect() {}

  afterConnect() {
    if (this.hasLogofieldTarget) {
      this.initFileField()
    }
    this.intializeOnHiddenValue()
  }

  intializeOnHiddenValue() {
    if (!this.hasOnHiddenValue) {
      if (this.hasCheckboxTarget) {
        this.onHiddenValue = !this.checkboxTarget.checked
      } else {
        this.onHiddenValue = false
      }
    }
  }

  onHiddenValueChanged() {
    if (this.hasOnHiddenValue) {
      this.updateState()
    }
  }

  changed(event) {
    if (event && event.currentTarget === this.checkboxTarget) {
      this.onHiddenValue = !this.checkboxTarget.checked
    } else {
      this.onHiddenValue = !this.onHiddenValue
    }
  }

  setHiddenForAllElements(elements, hiddenValue) {
    for (let index = 0; index < elements.length; index++) {
      elements[index].hidden = hiddenValue
    }
  }

  updateState() {
    this.setHiddenForAllElements(this.elementTargets, this.onHiddenValue)

    this.setHiddenForAllElements(this.showOnHiddenOnlyElementTargets, !this.onHiddenValue)
  }

  showInput(event) {
    if (this.checkboxTarget.checked) {
      this.logofieldTarget.classList.remove('hidden')
    } else {
      this.logofieldTarget.classList.add('hidden')
    }
  }

  readURL() {
    var input = this.inputTarget
    var output = this.outputTarget
    var maintainField = this.maintainfieldTarget

    if (input.files && input.files[0]) {
      output.firstElementChild.style.color = '#826f75'
      output.firstElementChild.innerHTML = `Attached: ${input.files[0].name}`
      output.classList.remove('hidden')
      maintainField.value = 'true'
    }
  }

  cleanFile(event) {
    event.preventDefault()
    var input = this.inputTarget
    var output = this.outputTarget
    var maintainField = this.maintainfieldTarget

    input.value = ''
    output.firstElementChild.innerHTML = ''
    output.classList.add('hidden')
    maintainField.value = 'false'
  }

  initFileField() {
    var output = this.outputTarget
    var maintainField = this.maintainfieldTarget

    if (this.checkboxTarget.checked) {
      this.logofieldTarget.classList.remove('hidden')
      if (this.hasErrorsValue && this.errorsValue) {
        output.firstElementChild.style.color = 'red'
        output.firstElementChild.innerHTML = this.errorsValue
        output.lastElementChild.classList.remove('hidden')
        output.classList.remove('hidden')
      } else if (this.hasFilenameValue && this.filenameValue) {
        maintainField.value = 'true'
        output.firstElementChild.style.color = '#826f75'
        output.firstElementChild.innerHTML = `Attached: ${this.filenameValue}`
        output.classList.remove('hidden')
      }
    } else {
      this.logofieldTarget.classList.add('hidden')
    }
  }
}
